import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReplayGlowing = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 78,
	height: 78,
	viewBox: "0 0 78 78",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M78 39C78 17.4609 60.5391 0 39 0C17.4609 0 0 17.4609 0 39C0 60.5391 17.4609 78 39 78C60.5391 78 78 60.5391 78 39Z",
			fill: "#212121"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .8,
			filter: "url(#filter0_f_80446_79)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M29.8345 20.0865C33.4637 18.5894 37.4464 18.2127 41.2849 19.0037C45.0991 19.7895 48.6034 21.6934 51.3648 24.4798L54.949 27.815L57.2195 25.5075C57.8705 24.8456 58.8502 24.6477 59.7009 25.006C60.5514 25.3643 61.1058 26.208 61.1058 27.1441V36.4019C61.1058 37.6801 60.087 38.7163 58.8296 38.7164H49.723C48.8023 38.7162 47.9724 38.1526 47.6201 37.2878C47.2677 36.423 47.4623 35.4273 48.1134 34.7654L50.3734 32.4673L46.9492 29.2816C46.9141 29.2489 46.8797 29.215 46.846 29.1808C44.975 27.2787 42.5943 25.9792 40.0011 25.4448C37.4078 24.9105 34.7168 25.1652 32.265 26.1767C29.8132 27.1881 27.709 28.9117 26.2152 31.1319C24.7213 33.3523 23.9039 35.9709 23.8655 38.6607C23.8272 41.3504 24.5697 43.9922 25.9996 46.2556C27.4295 48.519 29.4838 50.304 31.9058 51.3872C34.3277 52.4705 37.0099 52.8041 39.6173 52.3464C42.2247 51.8888 44.6415 50.66 46.5659 48.8138C47.8643 47.5682 49.9105 47.6285 51.1357 48.9486C52.3609 50.2686 52.301 52.3483 51.0027 53.5939C48.1541 56.3267 44.5766 58.1459 40.7171 58.8234C36.8577 59.5008 32.8874 59.0065 29.3025 57.4031C25.7176 55.7996 22.6768 53.1578 20.5603 49.8075C18.4438 46.4573 17.3453 42.5471 17.4021 38.5658C17.4589 34.5843 18.6684 30.7078 20.8796 27.4212C23.0908 24.1348 26.2054 21.5835 29.8345 20.0865Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.4345 20.6622C34.0637 19.1896 38.047 18.819 41.8855 19.5969C45.6996 20.37 49.2034 22.2433 51.9648 24.984L54.6091 27.4039L57.2195 24.7942C57.8705 24.1431 58.8502 23.9484 59.7009 24.3008C60.5514 24.6532 61.1058 25.4836 61.1058 26.4043V35.5104C61.1058 36.7677 60.087 37.7867 58.8296 37.7868H58.0099C57.7732 37.8127 57.534 37.8131 57.2968 37.7868H49.723C48.8023 37.7866 47.9724 37.2322 47.6201 36.3817C47.2677 35.531 47.4624 34.5519 48.1134 33.9008L50.0335 31.9801L47.5498 29.7067C47.5146 29.6745 47.4797 29.6413 47.446 29.6076C45.575 27.7368 43.1943 26.4588 40.6011 25.9332C38.0079 25.4077 35.3174 25.6579 32.8655 26.6527C30.4137 27.6476 28.309 29.3427 26.8152 31.5266C25.3213 33.7105 24.5045 36.2866 24.4661 38.9323C24.4279 41.5779 25.1697 44.1761 26.5996 46.4024C28.0295 48.6287 30.0839 50.3841 32.5058 51.4497C34.9277 52.5151 37.61 52.8437 40.2173 52.3936C42.8248 51.9434 45.2421 50.7349 47.1665 48.919C48.4649 47.6938 50.5105 47.753 51.7357 49.0514C52.9607 50.3497 52.9015 52.3954 51.6032 53.6205C48.7547 56.3085 45.1766 58.0975 41.3171 58.7639C37.4577 59.4302 33.4874 58.9441 29.9025 57.367C26.3176 55.7899 23.2768 53.1916 21.1603 49.8963C19.0438 46.6009 17.9453 42.7546 18.0021 38.8385C18.0589 34.9223 19.2684 31.1095 21.4796 27.8768C23.6908 24.6442 26.8054 22.1347 30.4345 20.6622Z",
			fill: "white"
		})
	] }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_f_80446_79",
		x: 9.40001,
		y: 10.6,
		width: 59.7058,
		height: 56.5187,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "BackgroundImageFix",
				result: "shape"
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				stdDeviation: 4,
				result: "effect1_foregroundBlur_80446_79"
			})
		]
	}) })]
});
export default SvgReplayGlowing;
